/**
 * features.js — feature-flag client.
 *
 * ROOM: OFF di default finché non c'è l'ok legale (vedi Nullum-rooms-spec.md §9).
 * Defense-in-depth: il server le blocca comunque (ROOMS_DISABLED, bypass founder).
 * Quando si vorrà esporre: mettere ROOMS_ENABLED = true qui E rimuovere il flag
 * server in functions/src/callable/rooms.ts.
 */

const ROOMS_ENABLED = true; // ATTIVO per tutti (2026-06-20) — scope whitelist-only
const FOUNDER_SIGIL_LOWER = 'imwondering_01';

/** Le Room sono visibili a questo utente? (flag globale, oppure founder per test) */
export function roomsVisible(sigil) {
  if (ROOMS_ENABLED) return true;
  const s = String(sigil || '').toLowerCase().replace(/^@/, '');
  return s === FOUNDER_SIGIL_LOWER;
}
